import { useFlags } from 'launchdarkly-react-client-sdk'
import { useMemo } from 'react'
import { AccountHomeTaskMapKey } from '../AccountHomeLink/AccountHomeLink'

const defaults: { [key: string]: AccountHomeTaskMapKey[] } = {
  providers: [
    'checkProviders',
    'findProviders',
    'checkPreventiveServices',
    'updatePharmacies',
    'updateDrugs'
  ],
  claims: ['checkClaims', 'getEmsns', 'checkDeductible'],
  plans: ['planDetailsLegacy', 'findPlans'],
  premiums: ['checkPremiums', 'payPremium'],
  settings: [
    'editAccountSettings',
    'manageReps',
    'getMedicareCard',
    'download',
    'connectedApps',
    'updateHealthInfo'
  ]
}
type usePersonalizedAllOptionsArgs = {
  eMsnEnrolled: boolean
}
export function usePersonalizedAllOptions ({
  eMsnEnrolled
}: usePersonalizedAllOptionsArgs): typeof defaults {
  const flags = useFlags()

  return useMemo(() => {
    const claims: AccountHomeTaskMapKey[] = eMsnEnrolled
      ? defaults.claims
      : ['checkClaims', 'getEmsns2', 'checkDeductible']

    const plans: AccountHomeTaskMapKey[] = !flags.accountHomePlansFuture
      ? defaults.plans
      : ['planDetails', 'findPlans']

    return {
      ...defaults,
      claims,
      plans
    }
  }, [eMsnEnrolled, flags.accountHomePlansFuture])
}
